import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import commonsEn from '../translation/commons_en.json'
import commonsPl from '../translation/commons_pl.json'

i18n
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        ns: ['commons'],
        defaultNS: 'commons',
        interpolation: {
            escapeValue: false, // not needed for react!!
        },
        resources: {
            en: {
                commons: commonsEn,
            },
            pl: {
                commons: commonsPl,
            },
        },
        react: {
            wait: true,
            useSuspense: false, // Disable suspense to avoid issues with Gatsby SSR
        },
    })

export default i18n;